import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Loader2 } from "lucide-react";

export default function DashboardCharts({ registrationsTrend, isLoading }) {
  return (
    <div className="mt-8">
      <div className="bg-white shadow rounded-xl p-5 lg:w-[50%]">
        <h2 className="font-popinsSemiBold text-base text-[#1E1B39]">
          Registrations Trend
        </h2>
        <p className="font-popinsRegular text-sm text-[#61758A] mt-0.5 mb-5">
          New user registrations — past 6 months
        </p>
        {isLoading ? (
          <div className="h-56 flex items-center justify-center">
            <Loader2 className="animate-spin text-[#3FC4E3]" size={24} />
          </div>
        ) : (
          <div className="h-56">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={registrationsTrend}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" tick={{ fontFamily: "popinsRegular", fontSize: 12 }} />
                <YAxis allowDecimals={false} tick={{ fontFamily: "popinsRegular", fontSize: 12 }} />
                <Tooltip formatter={(val) => [val, "Registrations"]} />
                <Line
                  type="monotone"
                  dataKey="count"
                  stroke="#0EA5E9"
                  strokeWidth={3}
                  dot={{ r: 4, fill: "#0EA5E9" }}
                  activeDot={{ r: 6 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}
